<template>
    <v-row align="center" justify="center">
      <v-col cols="6" align="center">
        <v-progress-circular class="text-center" indeterminate></v-progress-circular>
      </v-col>
    </v-row>
</template>

<script>
export default {
    
}
</script>